import {
  SIM_IS_RUNNING,
  SIM_UPDATE_DOWNLOAD_PROGRESS,
  SIM_ISVT_ENABLED,
  SIM_UPDATE_STATUS,
  SIM_IS_INSTALLED_REQUEST,
  SIM_IS_RUNNING_REQUEST,
  SIM_ISVT_ENABLED_REQUEST,
  SIM_POPUP_INFO,
} from '../constants/asimstatus';

export const updateSIMProgress = param => ({
  type: SIM_UPDATE_DOWNLOAD_PROGRESS,
  ...param,
});

export const updateSIMStatus = param => ({
  type: SIM_UPDATE_STATUS,
  ...param,
});

export const updateIsVTEabled = param => ({
  type: SIM_ISVT_ENABLED,
  ...param,
});

export const updateIsSIMRunning = param => ({
  type: SIM_IS_RUNNING,
  ...param,
});

export const getIsVTEabled = param => ({
  type: SIM_ISVT_ENABLED_REQUEST,
  ...param,
});

export const getIsSIMRunning = param => ({
  type: SIM_IS_RUNNING_REQUEST,
  ...param,
});

export const getIsSIMInstalled = param => ({
  type: SIM_IS_INSTALLED_REQUEST,
  ...param,
});

export const setSIMPopupInfo = payload => ({
  type: SIM_POPUP_INFO,
  payload,
});
